import React from 'react';
import { Hero } from '../components/Hero';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import { CallToAction } from '../components/CallToAction';
import { CheckoutSection } from '../components/CheckoutSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-312">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200/50" data-id="element-313">
        <div className="container mx-auto px-4 h-14 flex items-center justify-between" data-id="element-314">
          <div className="font-serif font-bold text-base text-pink-600 flex items-center gap-1.5" data-id="element-315">
            <span className="text-lg" data-id="element-316">🩰</span> MegaPack Danza Lista
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" data-id="element-317">
            <a href="#que-incluye" className="hover:text-pink-600 transition-colors" data-id="element-318">
              Qué Incluye
            </a>
            <a href="#beneficios" className="hover:text-pink-600 transition-colors" data-id="element-319">
              Beneficios
            </a>
            <a href="#testimonios" className="hover:text-pink-600 transition-colors" data-id="element-320">
              Testimonios
            </a>
            <a href="#comprar" className="bg-pink-600 text-white px-3.5 py-1.5 rounded-full hover:bg-pink-700 transition-colors text-xs font-bold uppercase tracking-wide" data-id="element-321">
              Comprar
            </a>
          </nav>
        </div>
      </header>

      <main data-id="element-322">
        <Hero data-id="element-323" />
        <ProductBreakdown data-id="element-324" />
        <div id="beneficios" data-id="element-325">
          <Benefits data-id="element-326" />
        </div>
        <CheckoutSection data-id="element-327" />
        <div id="testimonios" data-id="element-328">
          <Testimonials data-id="element-329" />
        </div>
        <CallToAction data-id="element-330" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-331">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-332">
          <div className="text-center md:text-left" data-id="element-333">
            <h3 className="text-white font-serif font-bold text-lg mb-2" data-id="element-334">
              🩰 MegaPack Danza Lista
            </h3>
            <p className="text-sm" data-id="element-335">
              Recursos educativos para docentes apasionados.
            </p>
          </div>
          <div className="text-sm text-center md:text-right" data-id="element-336">
            <p data-id="element-337">
              &copy; {new Date().getFullYear()} Todos los derechos reservados.
            </p>
            <p className="mt-1" data-id="element-338">Hecho con ❤️ para la comunidad de la danza.</p>
          </div>
        </div>
      </footer>
      <PurchasePopup data-id="element-339" />
    </div>;
}